module.exports = __webpack_public_path__ + "assets/img/10a.9ff27e5b.jpg";